import { CheckCircle, InfoCircle } from "flowbite-react-icons/solid";
import { useCallback, useState } from "preact/hooks";
import PropTypes from "prop-types";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";

CopyUrlClipboard.propTypes = {
  overlayURL: PropTypes.string.isRequired,
  overlayDemoModeURL: PropTypes.string,
  showCopyDemoModeLinkButton: PropTypes.bool,
  showDemoModeLinkTip: PropTypes.bool,
  setCurrentStep: PropTypes.func,
  disabled: PropTypes.bool,
};

export default function CopyUrlClipboard({
  overlayURL,
  overlayDemoModeURL = null,
  showCopyDemoModeLinkButton = false,
  showDemoModeLinkTip = true,
  setCurrentStep = (_step) => {},
  disabled = false,
}) {
  const [copied, setCopied] = useState(false);
  const [copiedDemo, setCopiedDemo] = useState(false);

  const didCopy = useCallback(
    (demoMode = false) => {
      if (demoMode) {
        setCopied(false);
        setCopiedDemo(true);
      } else {
        setCopied(true);
        setCopiedDemo(false);
        setCurrentStep(5);
      }

      const timeout = setTimeout(() => {
        if (demoMode) {
          setCopiedDemo(false);
        } else {
          setCopied(false);
        }
      }, 1800);

      toast(
        <>
          <CheckCircle />
          <span>Copied to clipboard</span>
        </>,
        {
          position: "top-center",
          className: "alert-success text-white",
        },
      );

      return () => {
        clearTimeout(timeout);
      };
    },
    [setCurrentStep],
  );

  return (
    <>
      <article className="prose text-xs mb-2 mt-2">
        Copy and paste the overlay link (below) into your streaming software
      </article>
      <input
        type="text"
        value={overlayURL}
        readOnly
        disabled={disabled}
        className="input input-bordered mb-4 w-full "
      />

      {showCopyDemoModeLinkButton && showDemoModeLinkTip && (
        <div role="alert" className="alert alert-info bg-blue-400 text-white border-blue-400 mb-2">
          <InfoCircle />
          <span className="text-sm">
            Tip: Use the demo link to visualize your overlay before getting donations.
          </span>
        </div>
      )}

      <div className="flex justify-between w-full">
        <CopyToClipboard text={overlayURL} onCopy={() => didCopy(false)}>
          <button
            type="button"
            disabled={disabled}
            data-track="copy-link"
            className={`btn ${copied ? "btn-neutral" : "btn-secondary"} basis-[48%] flex-grow flex items-center justify-center`}
          >
            <span>{copied ? "Copied" : "Copy Link to Clipboard"}</span>
          </button>
        </CopyToClipboard>

        {showCopyDemoModeLinkButton && (
          <>
            <span className="flex-grow" />
            <CopyToClipboard text={overlayDemoModeURL} onCopy={() => didCopy(true)}>
              <button
                type="button"
                disabled={disabled}
                data-track="copy-demo-link"
                className={`btn ${copiedDemo ? "btn-neutral" : "btn-accent"} basis-[48%] flex-grow flex items-center justify-center`}
              >
                <span>{copiedDemo ? "Copied Demo Link" : "Copy Demo Link to Clipboard"}</span>
              </button>
            </CopyToClipboard>
          </>
        )}
      </div>
    </>
  );
}
